/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupAssignmentUserUserType
 */
export interface UserGroupAssignmentUserUserType {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUserUserType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUserUserType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUserUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUserUserType
     */
    description?: string;
}

/**
 * Check if a given object implements the UserGroupAssignmentUserUserType interface.
 */
export function instanceOfUserGroupAssignmentUserUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserGroupAssignmentUserUserTypeFromJSON(json: any): UserGroupAssignmentUserUserType {
    return UserGroupAssignmentUserUserTypeFromJSONTyped(json, false);
}

export function UserGroupAssignmentUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignmentUserUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function UserGroupAssignmentUserUserTypeToJSON(value?: UserGroupAssignmentUserUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'type': value.type,
        'description': value.description,
    };
}

